












import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';

import {
	DxPopup,
	DxPosition,
	DxToolbarItem
} from 'devextreme-vue/popup';


@Component({
	components: {
		DxPopup, DxPosition,
		DxToolbarItem
	}
})
export default class Panel extends Vue {

	@Model('update:show-panel', { type: Boolean, default: false }) showPanel!: boolean | null;

	@Prop({ type: Boolean, default: true }) closeOnOutsideClick!: boolean;
	@Prop({ type: Boolean, default: false }) dragEnabled!: boolean;
	@Prop({ type: String, default: 'Set my title' }) title!: string;
	@Prop({ type: [ Number, String ], default: '100vh' }) height!: number | string;
	@Prop({ type: [ Number, String ], default: '40vw' }) width!: number | string;

	@Prop({ type: Object, default: () => ({})}) dxPopupProps: any;
	@Prop({ type: Object, default: () => ({})}) dxPositionProps: any;

	internalShowPanel = false;


/*
{ type: 'slide', duration: 400, from: { position: { my: 'right', at: 'right', of: window } }, to: { position: { my: 'center', at: 'center', of: window } }}


*/
	get internalProps() {
		return {
			'animation': { type: 'slide', duration: 0, from: { position: { my: 'right', at: 'right', of: window } }, to: { position: { my: 'center', at: 'center', of: window } }},
			...this.dxPopupProps,
			'close-on-outside-click': this.closeOnOutsideClick,
			'drag-enabled': this.dragEnabled,
			'height': this.height,
			'title': this.title,
			'visible': this.internalShowPanel,
			'width': this.width === '40vw' && (this.$screen.breakpoint === 'xs' || this.$screen.breakpoint === 'sm' || this.$screen.breakpoint === 'md') ? '100vw' : this.width
		};
	}

	get internalPositionProps() {
		return {
			at: 'right',
			my: 'right',
			...this.dxPositionProps,
		};
	}

	onUpdateVisible(value: boolean) {
		this.internalShowPanel = value;
		this.$emit('update:show-panel', value);
	}

	@Watch('showPanel', { immediate: true })
	onShowPanelChange(value: boolean | null) {
		if (value == null)
			this.internalShowPanel = false;
		else
			this.internalShowPanel = value;
	}

}

